<!-- eslint-disable vue/multi-word-component-names -->
<script>
import Filtro01 from '@/components/shared/relatorio/filtros/Filtro01.vue'

export default {
  extends: Filtro01,

  methods: {
    carregarListaEntidades() {
      this.entidadeService.getListaEntidadesPorUsuario().then((res) => {
        this.entidades = res
      })
    },

    carregarListaConsignatarias() {
      this.consignatariaService
        .getConsignatariaPorRelatorio('Consignacao')
        .then((res) => {
          this.consignatarias = res
        })
    },
  },
}
</script>
